export default __webpack_public_path__ + "static/media/lifestyleImg.d69e214b.png";